import { LoaderCircle } from "lucide-react";

export default function LoadingPage() {
  return (
    <div className="absolute top-[50%] right-[0] flex justify-center w-full">
      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
    </div>
  );
}
